import React from "react";
import { useOutsideClick } from "src/utils/useOutsideClick";
import styles from "./styles.module.scss";
import TrendUp from "@assets/icons/trendUp";
import TrendDown from "@assets/icons/trendDown";
import { TooltipData } from "@components/TreeChart/chart.types";
import { getTooltipValueName } from "@components/Tooltip/utils";
import classNames from "classnames";

interface CustomerJourneyTooltipProps {
  data: TooltipData;
  clearStyles: () => void;
  position: number;
  positionX?: number;
}

export const CustomerJourneyTooltip: React.FC<CustomerJourneyTooltipProps> = ({
  data,
  clearStyles,
  position,
  positionX,
}) => {
  const tooltipRef = useOutsideClick(clearStyles);

  return (
    <div
      className={styles.tooltip}
      ref={tooltipRef}
      style={{
        top: `${position + 200}px`,
        left: positionX ? `${positionX + 60}px` : "0",
        position: "absolute",
        zIndex: 1000,
      }}
    >
      <div className={styles.header}>
        <h4 className={styles.title}>{data.name}</h4>
      </div>

      <div className={styles.content}>
        {Object.entries(data).map(([key, value]) => {
          console.log("key", key, "value", value);
          if (key === "name") {
            return null;
          }
          if (typeof value !== "object" || !value) {
            return null;
          }
          return (
            <div key={key} className={classNames(styles.row, styles[key])}>
              <div className={styles.label}>{getTooltipValueName(key)}</div>
              <div className={styles.value}>
                <span>{value.value}</span>
                {value.increaseIcon === "trendUp" ? <TrendUp /> : <TrendDown />}
                <span
                  className={
                    value.increaseIcon === "trendUp"
                      ? styles.increaseUp
                      : styles.increaseDown
                  }
                >
                  {value.increase}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
